import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import authReducer from './authSlice';
import bookedDialogReducer from './bookedDialogSlice';
import campaignsReducer from './campaignsSlice';
import campaignStatusesReducer from './campaignStatusesSlice';
import companiesReducer from './companiesSlice';
import customizationReducer from './customizationSlice';
import menuCampaignsReducer from './menuCampaignsSlice';
import newArtBriefReducer from './newArtBriefSlice';
import newCampaignReducer from './newCampaignSlice';
import notificationReducer from './notificationSlice';
import paymentMethodsReducer from './paymentMethodsSlice';
import snackbarReducer from './snackbarSlice';

const combinedReducer = combineReducers({
  auth: authReducer,
  campaigns: campaignsReducer,
  companies: companiesReducer,
  paymentMethods: paymentMethodsReducer,
  newCampaign: newCampaignReducer,
  newArtBrief: newArtBriefReducer,
  campaignStatuses: campaignStatusesReducer,
  menuCampaigns: menuCampaignsReducer,
  snackbar: snackbarReducer,
  customization: customizationReducer,
  bookedDialog: bookedDialogReducer,
  notificationDialog: notificationReducer
});

const reducer = (state, action) => {
  if (action.type === 'auth/logout/fulfilled') {
    state = undefined;
  }

  return combinedReducer(state, action);
};

export const store = configureStore({ reducer });
